import { palette } from '../../styles/tokens';
import { CREW_STATUSES, CREW_STATUS_ORDER } from './config';
import type { CrewMember } from './hooks';

interface Props {
  crew: CrewMember[];
  onCrewClick: (member: CrewMember) => void;
}

export function CrewSidebar({ crew, onCrewClick }: Props) {
  const sorted = [...crew].sort((a, b) => {
    const ai = CREW_STATUS_ORDER.indexOf(a.crewStatus);
    const bi = CREW_STATUS_ORDER.indexOf(b.crewStatus);
    if (ai !== bi) return ai - bi;
    return a.first_name.localeCompare(b.first_name);
  });

  const available = crew.filter(c => c.crewStatus === 'available').length;

  // Group by status
  const groups = CREW_STATUS_ORDER.map(status => ({
    status,
    config: CREW_STATUSES[status],
    members: sorted.filter(c => c.crewStatus === status),
  })).filter(g => g.members.length > 0);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 0 10px' }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: palette.g800 }}>Crew</div>
        <span style={{ fontSize: 11, color: available < 2 ? palette.red : palette.g500, fontWeight: 600 }}>
          {available}/{crew.length} available
        </span>
      </div>

      <div>
        {groups.map(g => (
          <div key={g.status} style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 10, fontWeight: 600, color: palette.g400, textTransform: 'uppercase', letterSpacing: '0.06em', padding: '4px 0', display: 'flex', alignItems: 'center', gap: 4 }}>
              <span style={{ color: g.config.color }}>{g.config.dot}</span>
              {g.config.label} ({g.members.length})
            </div>
            {g.members.map(m => {
              const isOff = m.crewStatus === 'off_today';
              return (
                <div key={m.id} onClick={() => onCrewClick(m)} style={{
                  display: 'flex', alignItems: 'center', gap: 8, padding: '6px 8px', borderRadius: 6,
                  cursor: 'pointer', opacity: isOff ? 0.5 : 1, transition: 'background 0.1s',
                }}
                  onMouseEnter={e => (e.currentTarget.style.background = palette.g50)}
                  onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}>
                  {/* Avatar */}
                  <div style={{
                    width: 28, height: 28, borderRadius: 14, background: palette.accentWash,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 11, fontWeight: 600, color: palette.accentDeep, flexShrink: 0,
                  }}>
                    {m.first_name.charAt(0)}{m.last_name.charAt(0)}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 12, fontWeight: 500, color: palette.g800, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {m.first_name} {m.last_name}
                    </div>
                    {m.currentJobTitle && (
                      <div style={{ fontSize: 10, color: palette.g400, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {m.currentJobTitle}
                      </div>
                    )}
                  </div>
                  <span style={{ width: 6, height: 6, borderRadius: 3, background: g.config.color, flexShrink: 0 }} />
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}
